import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import t from "@/lang/lang";
import {
  CommitmentsTable,
  CommitmentsTableFilters,
} from "@/services/backend/relationships/components/commitments-table";
import { NavLink, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import { ListCommitmentsRequest } from "@/services/backend/relationships/api/service";
import {
  Commitment,
  Relationship,
} from "@/services/backend/relationships/types/relationship";
import { CreateCommitmentsFromConfirmationDialog } from "@/routes/processes/[processId]/htz/commitments/_components/create-commitments-from-confirmation-dialog";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { ServiceObjectLink } from "@/routes/_components/links/service-object-link";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { HtzBreadcrumbs } from "@/routes/processes/[processId]/htz/_components/htz-breadcrumbs";

export function CommitmentsRoute() {
  const { processId } = useParams();
  const [request, setRequest] = useState<ListCommitmentsRequest>({
    process: {
      active: true,
      values: [processId!],
    },
    offset: 0,
    limit: 10,
  });
  const [selection, setSelection] = useState<Commitment[]>([]);

  const { data: process } = useProcessesProcessShowQuery({ id: processId! });

  const renderCommitmentLink = useCallback(
    (
      commitment: Commitment,
      relationship: Relationship,
      children: ReactNode,
    ) =>
      commitment.processId !== null ? (
        <NavLink
          to={`/processes/${commitment.serviceKind}/${commitment.processId}/commitments/${commitment.relationshipId}/${commitment.id}`}
        >
          {children}
        </NavLink>
      ) : (
        <NavLink
          to={`/customers/${relationship.customerId}/relationships/${commitment.relationshipId}/commitments/${commitment.id}`}
        >
          {children}
        </NavLink>
      ),
    [],
  );

  const renderDocumentLink = useCallback(
    (path: string, children: ReactNode) => (
      <NavLink to={path}>{children}</NavLink>
    ),
    [],
  );

  if (!process) return null;

  const breadcrumbs = (
    <HtzBreadcrumbs customerId={process.customerId} processId={process.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Sollstellungen")}</BreadcrumbPage>
      </BreadcrumbItem>
    </HtzBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <MilestonePage>
        <MilestonePageHeader>
          <MilestonePageTitle>{t("Sollstellungen")}</MilestonePageTitle>
        </MilestonePageHeader>
        <MilestonePageContent>
          <div className="grid gap-2">
            <div className="flex justify-between">
              <CommitmentsTableFilters
                request={request}
                onRequestChange={setRequest}
                selection={selection}
                onSelectionChange={setSelection}
                hideServiceObjectFilter={false}
              />
              <CreateCommitmentsFromConfirmationDialog process={process} />
            </div>
            <CommitmentsTable
              request={request}
              onRequestChange={setRequest}
              selection={selection}
              onSelectionChange={setSelection}
              showBorder
              hideServiceObject={false}
              renderCommitmentLink={renderCommitmentLink}
              renderDocumentLink={renderDocumentLink}
              renderServiceObjectLink={(serviceObjectId) => (
                <ServiceObjectLink id={serviceObjectId} />
              )}
            />
          </div>
        </MilestonePageContent>
      </MilestonePage>
    </ProcessPageMainTemplate>
  );
}
